module.exports = __webpack_public_path__ + "assets/img/rank6.346dfde5.png";